/** Fired once when the consent-gated browser PostHog singleton is ready. */
export const POSTHOG_BROWSER_INITIALIZED_EVENT = "posthog_browser_initialized";
